import {Injectable, Signal} from '@angular/core';
import {SignalEntityQuery} from '../../state/signal-entity.store';
import {FlowState, QuestionFlowSessionStore} from './question-flow-session.store';
import {FlowSessionDetails} from '../../models/underwriter.model';

@Injectable({providedIn: 'root'})
export class QuestionFlowSessionQuery extends SignalEntityQuery<FlowSessionDetails, FlowState> {
  readonly session: Signal<FlowState> = this.store.stateSignal;

  constructor(protected store: QuestionFlowSessionStore) {
    super(store);
  }
}
